<button
  class="btn btn-primary"
  type="button"
  (click)="openUploadModal()"
>
  {{ "button_labels.upload_csv" | translate }}
</button>
